//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('holiday', {
//        templateUrl: 'views/components/views/holiday/holiday.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'holidayService', 'logisticService', function ($stateParams, stateService, translateService, modalService, holidayService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2HoliDayKeyno = $stateParams.p2_holyday_keyno;
//            let countryId = $stateParams.country_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListCountries: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await holidayService.getEdit({
//                    p2_holyday_keyno: p2HoliDayKeyno,
//                    country_id: countryId
//                }))[0];
//            }

//            async function loadCountries() {
//                vm.model.selectListCountries = (await logisticService.listCountries());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                holidayService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].status_no !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                            message: response[0].status_message,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    holidayService.deleteItem({ p2_holyday_keyno: vm.model.edit.p2_holyday_keyno }).then(function (response) {
//                        if (response[0].status_no !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                                message: response[0].status_message,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadCountries();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
